import { createContext } from 'react';
import type { User, AuthError } from '@supabase/supabase-js';

export interface AuthContextType {
  user: User | null;
  loading?: boolean;
  signUp: (email: string, password: string) => Promise<{ error?: AuthError }>;
  signIn: (email: string, password: string) => Promise<{ data?: { user: User | null }; error?: AuthError }>;
  signInWithGoogle: (credential: string) => Promise<{ error?: AuthError }>;
  signOut: () => Promise<void>;
  forgotPassword: (email: string) => Promise<{ error?: AuthError }>;
  resetPassword: (newPassword: string) => Promise<{ error?: AuthError }>;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  loading: false,
  signUp: async () => ({}),
  signIn: async () => ({}),
  signInWithGoogle: async () => ({}),
  signOut: async () => {},
  forgotPassword: async () => ({}),
  resetPassword: async () => ({}),
});
